import {
  Component,
  OnInit,
  Input,
  Output,
  ChangeDetectorRef,
  EventEmitter
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from 'app/shared/services/core.service';
import { PdfDialogComponent } from 'app/shared/pdf-dialog/pdf-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-vexatious-clauses',
  templateUrl: './vexatious-clauses.component.html',
  styleUrls: ['./vexatious-clauses.component.css', '../../common-styles.scss'],
  standalone: false
})
export class VexatiousClausesComponent implements OnInit {
  @Input() plan: any;
  userInfo: any;
  @Output() acceptPlan = new EventEmitter();

  constructor(
    private translateService: TranslateService,
    private coreService: CoreService,
    private ref: ChangeDetectorRef,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.userInfo = this.coreService.getUserInfo();
    console.log(this.userInfo);
  }

  openPdf(pdfUrl: string) {
    const content: any = {
      pdfUrl: pdfUrl
    };
    const modal = this.modalService.show(PdfDialogComponent, {
      class: 'pdw-view'
    });
    (<PdfDialogComponent>modal.content).showModal(content);
  }

  accept() {
    if (
      this.plan.termsConditions &&
      this.plan.myLtiForm &&
      this.plan.vexatiousClauses
    ) {
      this.acceptPlan.emit();
    }
  }
}
